import defaultLoader from "./svg/default-loader.svg";
const Images = {
  defaultLoader
};
export { Images };